/**
 * Interface for the Edge data. This must be in sync with the backend: "db.php"
 */

interface IEdgeData {
    ID: string;
    Name: string;
    OverrideNames: string[];
    UnitPrice: number | null;
    Materials: any; // TODO: create material interface type
    ProductImage: string;
    Width: number;
    Thickness: number;
    Oriented: number;
    Status?: number | null;
}

export default IEdgeData;
